module.exports = __webpack_public_path__ + "assets/ed0b0635138a15a8ca052e6d5ecaa094.mp3";